export const transformNonImportedRegistration = (registrationNumber: string, isImported: boolean): string => {
  if (!isImported && registrationNumber.includes('-')) {
    registrationNumber = registrationNumber.replaceAll('-', '');
  }
  return isImported
    ? registrationNumber
    : `${registrationNumber.substring(0, 2)}-${registrationNumber.substring(2, 5)}-${registrationNumber.substring(5)}`;
};
